import React from "react";
import { Box, Typography } from "@mui/material";
import { useDrop } from "react-dnd";
import { ITEM_TYPE_TOOL } from "./ToolItem";

function AgentDropZone({ agent, onDropTool }) {
  const [{ isOver, canDrop }, dropRef] = useDrop(() => ({
    accept: ITEM_TYPE_TOOL,
    drop: (item) => onDropTool(agent, item.tool_name),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  }));

  const isActive = isOver && canDrop;

  return (
    <Box
      ref={dropRef}
      sx={{
        minHeight: "60px",
        minWidth: "180px",
        margin: "8px",
        padding: "8px",
        textAlign: "center",
        border: "2px dashed #ccc",
        borderRadius: "4px",
        backgroundColor: isActive ? "#e0f7fa" : "#fafafa",
        transition: "background-color 0.2s ease"
      }}
    >
      <Typography variant="body2" fontWeight="bold">
        {agent.agent_id}
      </Typography>
      <Typography variant="caption">
        {isActive ? "¡Suelta la Tool aquí!" : "Arrastra una Tool aquí para asignarla"}
      </Typography>
    </Box>
  );
}

export default AgentDropZone;
